import Message, { type MessageProps } from 'carbon-react/lib/components/message';

export type ToastType = MessageProps['variant'];

export interface CarbonToastProps {
  closeToast?: () => void;
  variant: ToastType;
  message: string;
}

const CarbonToast = ({ closeToast, variant, message }: CarbonToastProps) => {
  return (
    <Message onDismiss={closeToast} open variant={variant}>
      <div data-toast-type={variant}>{message}</div>
    </Message>
  );
};

export default CarbonToast;
